import React from 'react';
import { Layout as AntLayout, Steps } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const { Header, Content, Footer } = AntLayout;

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  // 🌟 核心：如果是参数页，直接返回内容，不渲染任何外层的导航栏和步骤条！
  if (location.pathname === '/parameters') {
    return <>{children}</>;
  }
  const stepItems = [
    { title: '上传' },
    { title: '参数' },
    { title: '结果' },
  ];

  const getCurrentStep = () => {
    if (location.pathname === '/upload') return 0;
    if (location.pathname === '/parameters') return 1;
    if (location.pathname === '/result') return 2;
    return 0;
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: 'rgba(0, 10, 30, 0.9)',
        border: '1px solid rgba(0, 229, 255, 0.2)',
        borderRadius: '0 0 12px 12px',
        padding: '14px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 4px 30px rgba(0, 229, 255, 0.1)',
        
        maxWidth: '100%',
        width: 'calc(100% - 210px - 210px)',
        margin: '0 auto',
        
        
        height: 'auto',
        lineHeight: 'normal',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: 'linear-gradient(135deg, #00e5ff, #ff6b35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 20, fontWeight: 700, color: '#000',
            boxShadow: '0 0 20px rgba(0,229,255,0.3)',
            cursor: 'pointer',
          }} onClick={() => navigate('/')}>P</div>
          <div>
            <div style={{
              fontSize: 17, fontWeight: 600, letterSpacing: 1,
              background: 'linear-gradient(135deg, #00e5ff, #ff6b35)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              cursor: 'pointer',
            }} onClick={() => navigate('/')}>PROLEAN</div>
            <div style={{ fontSize: 10, color: '#8899aa', letterSpacing: 2, fontWeight: 400 }}>
              INTELLIGENT MANUFACTURING
            </div>
          </div>
        </div>
        <ul style={{
          display: 'flex', gap: 28, listStyle: 'none', margin: 0, padding: 0,
        }}>
          <li style={{
            color: location.pathname === '/upload' ? '#00e5ff' : '#8899aa',
            cursor: 'pointer', fontSize: 14, fontWeight: 500,
            transition: 'color 0.3s', position: 'relative',
          }} onClick={() => navigate('/upload')}>
            📦 上传图纸 <span style={{ fontSize: 10, color: location.pathname === '/upload' ? '#00e5ff' : '#8899aa' }}>Upload</span>
            {location.pathname === '/upload' && <div style={{ position: 'absolute', bottom: -6, left: 0, right: 0, height: 2, background: '#00e5ff', boxShadow: '0 0 10px #00e5ff' }} />}
          </li>
          <li style={{
            color: location.pathname === '/parameters' ? '#00e5ff' : '#8899aa',
            cursor: 'pointer', fontSize: 14, fontWeight: 500,
            transition: 'color 0.3s', position: 'relative',
          }} onClick={() => navigate('/parameters')}>
            ⚙️ 参数设置 <span style={{ fontSize: 10, color: location.pathname === '/parameters' ? '#00e5ff' : '#8899aa' }}>Parameters</span>
            {location.pathname === '/parameters' && <div style={{ position: 'absolute', bottom: -6, left: 0, right: 0, height: 2, background: '#00e5ff', boxShadow: '0 0 10px #00e5ff' }} />}
          </li>
          <li style={{
            color: location.pathname === '/result' ? '#00e5ff' : '#8899aa',
            cursor: 'pointer', fontSize: 14, fontWeight: 500,
            transition: 'color 0.3s', position: 'relative',
          }} onClick={() => navigate('/result')}>
            📊 报价结果 <span style={{ fontSize: 10, color: location.pathname === '/result' ? '#00e5ff' : '#8899aa' }}>Result</span>
            {location.pathname === '/result' && <div style={{ position: 'absolute', bottom: -6, left: 0, right: 0, height: 2, background: '#00e5ff', boxShadow: '0 0 10px #00e5ff' }} />}
          </li>
        </ul>
      </Header>
      <Content style={{ maxWidth: '100%', margin: '0 auto', width: '100%', padding: '0', position: 'relative', zIndex: 2 }}>
        <Steps current={getCurrentStep()} items={stepItems} style={{ marginBottom: 36, maxWidth: '100%', width: 'calc(100% - 210px - 210px)',
        margin: '0 auto', padding: '0' }} />
        {children}
      </Content>
      <Footer style={{
        textAlign: 'center', background: 'transparent', color: '#8899aa',
        fontSize: 14, borderTop: '1px solid rgba(0,229,255,0.08)',
        padding: '30px', marginTop: 60,
      }}>
        Prolean AI Quote ©{new Date().getFullYear()}
      </Footer>
    </AntLayout>
  );
}
